import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=7974bca9&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7974bca9')) {
      api.createRecord('7974bca9', component.options)
    } else {
      api.reload('7974bca9', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=7974bca9&", function () {
      api.rerender('7974bca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Y3EaIWyx9STN/JS/cancellationPolicy.vue"
export default component.exports